import type { TFunction } from "i18next";
import { DomainTopics } from "@nexus/contracts";
import type { EventJobStatus } from "@/features/events/api/events.api";
import { stripTopicPrefix } from "../lib/event-row-display";

export const EVENT_FILTER_ALL = "all";

export interface EventFilterOption {
  value: string;
  label: string;
}

const EVENT_STATUSES: readonly EventJobStatus[] = [
  "PENDING",
  "PROCESSING",
  "COMPLETED",
  "FAILED",
] as const;

const STATUS_LABEL_FALLBACK: Record<EventJobStatus, string> = {
  PENDING: "Pending",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

/**
 * Option labels are user-facing, and module scope cannot call `useTranslation`,
 * so these take `t` from the caller (see the `translateBrandColorLabel` pattern).
 */
export function buildEventStatusOptions(t: TFunction): EventFilterOption[] {
  return [
    { value: EVENT_FILTER_ALL, label: t("admin.events.filters.status", "All statuses") },
    ...EVENT_STATUSES.map((status) => ({
      value: status,
      label: t(`admin.events.status.${status}`, STATUS_LABEL_FALLBACK[status]),
    })),
  ];
}

export function buildEventTopicOptions(t: TFunction): EventFilterOption[] {
  return [
    { value: EVENT_FILTER_ALL, label: t("admin.events.filters.topic", "All topics") },
    ...Object.values(DomainTopics).map((topic) => ({
      value: topic,
      label: stripTopicPrefix(topic),
    })),
  ];
}
